function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

var wFlag=window.innerWidth>750

function onViewLoad(className) {
    const elements = $(className).get();
    
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting) {
                const video = entry.target
                video.src = video.dataset.src
                video.load()
                observer.unobserve(video);
            }
        });
    }, { threshold:0,rootMargin: '500px', });
    
    elements.forEach(el => observer.observe(el));
}

onViewLoad('.lazy_video')

$(()=>{
    var country = getCookie('user_country');
    if(country == 'BR' || country == 'UY' || country == 'PY' || country == 'AR' || country == 'BO'){
        window.location.href = 'https://www.oxbar.com/pages/maze-x-br'
    }

    //box2 
    showUp('.box2_title')
    ScrollTrigger.create({ 
        trigger:'.box2_items',
        start:'top bottom-=20%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        // markers:true,
        animation:gsap.timeline()
            .from('.box2_items div',{opacity:0,y:'2rem',stagger:0.2})
    })

    //box3
    ScrollTrigger.create({
        trigger:'.box3',
        start:wFlag?'top top+=20%':'top center',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .from('.box3_light',{clipPath:wFlag?'inset(0% 100% 0% 0%)':'inset(0% 0% 100% 0%)',duration:1})
            .from('.box3_bg',{opacity:0})
    })
    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box3_1',
            start:'top center',
            end:'+=0%',
            toggleActions:'play none none reverse',
            // markers:true,
            animation:gsap.timeline()
                .from('.box3_bg1',{opacity:0})
                .from('.box3_title',{opacity:0,y:'2rem'})
        })
    }else{
        showUp('.box3_title')
    }

    //box4
    showUp('.box4_title')
    if(wFlag){
        showUp('.box4_icon')
    }

    //box5
    showUp('.box5_title')
    ScrollTrigger.create({
        trigger:'.box5',
        start:wFlag?'top top+=10%':'top center',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box5_icon',{x:0,y:0,scale:1,duration:1})
    })

    //box6
    showUp('.box6_title')
    ScrollTrigger.create({
        trigger:'.box6',
        start:wFlag?'top top+=30%':'top center',
        end:'+=0%',
        //toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box6_text',{x:0,y:0,scale:1,opacity:1,duration:0.5})
    })

    //box7
    showUp('.box7_title')
    ScrollTrigger.create({
        trigger:'.box7',
        start:wFlag?'top+=30% top+=2%':'top+=30% top+=8%',
        end:'+=0%',
        toggleActions:'play none none reverse',
        animation:gsap.timeline()
            .to('.box7_text1',{opacity:0})
            .to('.box7_text2',{opacity:1},'<')
            .to('.box7_img img:last-child',{opacity:1},'<')
    })
    ScrollTrigger.create({
        trigger:'.box7',
        start:wFlag?'top top+=2%':'top top+=8%',
        end:'+=60%',
        pin:true
    })

    //box8
    showUp('.box8_title')

    //flavorsSwiper
    new Swiper('.flavorsSwiper', {
        slidesPerView:wFlag?3:1.5,
        centeredSlides: true,
        autoplay:true,
        navigation: {
            nextEl: '.flavorsSwiper-button-next',
            prevEl: '.flavorsSwiper-button-prev',
        }
    })

    //flavors specs package
    showUp('.flavors_title')
    showUp('.specs_img')
    showUp('.package_title')
})